export const generateArrayOfNumbers = (start: number = 0, end: number) => {
	const arrayOfNumbers = [];
	for (let i = start; i < end; i += 1) {
		arrayOfNumbers.push(i);
	}
	return arrayOfNumbers;
};
